// @ts-nocheck
import React, { useState } from 'react';
import { MultipleTagSelector } from 'sonata-react-components';

type Props = {
  availableMetrics: { label: string; value: string }[];
  className: string;
  defaultSelectedMetrics: string[];
  onMetricSelectedChanged: (newMetricSelected: string[]) => void;
};

type State = {
  selectedMetrics: string[];
};

function AIInsightsMetricKpisSelector({
  availableMetrics,
  className,
  defaultSelectedMetrics,
  onMetricSelectedChanged
}: Props) {
  const [{ selectedMetrics }, setState] = useState<State>({
    selectedMetrics: defaultSelectedMetrics
  });

  const handleColumnsSelectedChanged = (newSelectedMetrics: string[]) => {
    setState(prevState => ({
      ...prevState,
      selectedColumns: newSelectedMetrics
    }));
    onMetricSelectedChanged(newSelectedMetrics);
  };

  return (
    <MultipleTagSelector
      className={className}
      items={availableMetrics}
      mark
      onChange={ids => handleColumnsSelectedChanged(ids)}
      selectedItems={selectedMetrics}
      textColor="simpleSelectorTagText"
    />
  );
}

export default AIInsightsMetricKpisSelector;
